<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12">
        <px-autocomplete-cadastro-adicional
          :dense="dense"
          search-by-start-only
          type="CONDICAO_PAGAMENTO"
          label="Condição de pagamento"
          required
          class="required rounded-tag-small"
          v-model="formData.condicaoPagamento"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
